import { render, staticRenderFns } from "./chatgpt.component.vue?vue&type=template&id=703cc8a5&scoped=true"
import script from "./chatgpt.component.vue?vue&type=script&lang=js"
export * from "./chatgpt.component.vue?vue&type=script&lang=js"
import style0 from "./chatgpt.component.vue?vue&type=style&index=0&id=703cc8a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703cc8a5",
  null
  
)

export default component.exports